<template>
  <div v-if="getProjectId" class="workReports">
    <div class="titleRow">
      <span id="titleAndProjectName">
        <h1 id="title">{{ $t(localeConsts.workReportsTitle) }}</h1>
        <span id="projectName"> {{ getProjectName }} </span>
      </span>
    </div>
    <work-reports-professor v-if="getIsSupervisor"></work-reports-professor>
    <work-reports-student v-else></work-reports-student>
  </div>
</template>

<script>
import WorkReportsProfessor from './Professors/WorkReportsProfessor.vue'
import WorkReportsStudent from './Students/WorkReportsStudent.vue'

import mapGettersMixin from '../../mixins/mapGettersMixin'

export default {
  name: 'WorkReports',
  components: {
    WorkReportsStudent,
    WorkReportsProfessor
  },
  mixins: [mapGettersMixin],
  data() {
    return {
      localeConsts: {
        workReportsTitle: 'WORKREPORTS.TITLE'
      }
    }
  }
}
</script>

<style lang="scss">
$text-color: #8b69a9;

.workReports {
  width: 100%;
}

.titleRow {
  color: $text-color;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

#titleAndProjectName {
  display: flex;
  align-items: baseline;
}

#title {
  color: $text-color;
}

#projectName {
  margin-left: 20px;
  font-size: 30px;
}
</style>
